import { ComponentPropsWithRef } from "react";
import styled from "styled-components";

// TEXT

// STYLES
export const IconHorizontal = styled.svg<{ $small?: boolean }>`
  width: ${({ $small }) => ($small ? "1rem" : "1.3125rem")};
`;

export const IconVertical = styled.svg<{ $small?: boolean }>`
  height: ${({ $small }) => ($small ? "1rem" : "1.3125rem")};
`;

// DATA

// TYPES
export interface Props extends ComponentPropsWithRef<"svg"> {
  small?: boolean;
  className?: string;
  horizontal?: boolean;
}

// FUNCTIONS

// ASSETS
